<template>
  <div class="container" v-if="calendarevents.length > 0">
    <div class="row">
      <div class="col-12">
        <button type="button" class="btn" v-bind:class="{ 'btn-outline-primary': selectevents === false, 'btn-primary': selectevents === true }" @click="selectevents = !selectevents">Kurse auswählen</button>
        <button type="button" class="btn btn-success" style="margin-left: 12px;" v-if="selectedevents.length > 0" @click="setmodalshoppingcart()">Weiter</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="d-block">
          <ul class="schedule_events">
            <li class="schedule_events_day" v-for="day1 in days" v-if="geteventsofday(day1).length > 0">
              <div class="col-md-12">
                <div class="row">
                  <h5>{{ new Date(day1).formatDate('dddd') }}, {{ new Date(day1).formatDate('DD.MM.') }}</h5>
                </div>
                <div class="row">
                  <ul class="schedule_events_group">
                    <li class="schedule_events_group_event" v-for="event in geteventsday(day1)" v-if="checkifeventcanbebooked(event)">
                      <div class="card" v-bind:style="{ 'background-color': getservicedata(event.serviceid).color }" style="margin-right: 12px; width: 90%; flex-shrink: 0;">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-sm-7">
                              <p class="card-text">{{ gettimeformat(event.datestart) }} - {{ gettimeformat(event.dateend) }}</p>
                              <h5 class="card-title">{{ getservicedata(event.serviceid).description }}</h5>
                            </div>
                            <div class="col-sm-5">
                              <div v-if="selectevents === true">
                                <label class="label float-right" @click="selectevent($event,event)">
                                  <input class="label__checkbox" :checked="checkifeventislist(event)" type="checkbox"/>
                                  <span class="label__text">
                                    <span class="label__check">
                                      <i class="fa fa-check icon" v-if="checkifeventislist(event)"></i>
                                    </span>
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="definedlocations === ''">
                            <div class="col-sm-12">
                              <span class="badge badge-pill badge-secondary float-right">{{ getlocation(event.locationid).name }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'calendar_select',
  components: {
    mapState
  },
  props: {
    companyid: String,
    definedlocations: '',
    definedservices: '',
  },
  data () {
    return {
      uri: '',
      activecw: '',
      calendarevents: [],
      companyservices: [],
      selectevents: false,
      firstday: new Date(),
      lastday: new Date(),
      days: [],
      timeslots: [
        { name: '1', starttime: '7:00', endtime: '8:59' },
        { name: '2', starttime: '9:00', endtime: '10:59' },
        { name: '3', starttime: '11:00', endtime: '12:59' },
        { name: '4', starttime: '13:00', endtime: '14:59' },
        { name: '5', starttime: '15:00', endtime: '16:59' },
        { name: '6', starttime: '17:00', endtime: '18:59' },
        { name: '7', starttime: '19:00', endtime: '20:59' }
      ]
    }
  },
  created: function () {
    if (process.env.NODE_ENV === 'development') {
      this.uri = '/calendarrequest'
    } else if (process.env.NODE_ENV === 'production') {
      this.uri = 'https://api.mycrogym.com/calendarrequest/'
    }
    let today = new Date()
    this.firstday = new Date()
    this.firstday.setHours(0,0,0)
    this.lastday = new Date()
    this.lastday.setDate(this.lastday.getDate() + 13)
    this.lastday.setHours(23,59,0)
    this.activecw = new Date().getWeekNumber()
  },
  mounted: function () {
    this.getdatafromserver()
    this.getdays()
  },
  computed: {
    ...mapState({
      // calendarevents: state => state.calendarevents,
      selectedevents: state => state.selectedevents,
      services: state => state.services,
      locations: state => state.locations
    })
  },
  methods: {
    getlocation: function (locationid) {
      return this.locations.find(location => location.id === locationid)
    },
    checkifeventcanbebooked: function (event) {
      let result = true
      if (event.maxattendees !== null) {
        if (Number(event.maxattendees) > Number(event.countedbookings)) {
          result = true
          } else {
          result = false
          }
      } else {
        result = true
      }
      return result
    },
    setmodalshoppingcart () {
      this.$store.commit('showorhideshoppingcart')
      return false
    },
    selectevent (ev,slot) {
      ev.preventDefault()
      let checkslot = this.selectedevents.filter(event => event.id === slot.id)
      this.$store.commit('addorremoveslot',slot)
      return false
    },
    checkifeventislist (slot) {
      let checkslot = this.selectedevents.filter(event => event.id === slot.id)
      let result = false
      if (checkslot.length > 0) result = true
      return result
    },
    gettimeformat (datetime) {
      return new Date(datetime).formatDate('HH:mm')
    },
    getservicedata: function (serviceid) {
      return this.services.find(service => service.id === serviceid)
    },
    geteventsofday: function (day) {
      let datestring = new Date(day).formatDate('YYYY-MM-DD')
      let events = this.calendarevents.filter(event => datestring === new Date(event.datestart).formatDate('YYYY-MM-DD') && event.archive === 0)
      return events
    },
    geteventsoftimeslot: function (day, starttime, endtime) {
      let newdatestart = new Date(day)
      let newdateend = new Date(day)
      let starttimeobj = starttime.split(":")
      let endtimeobj = endtime.split(":")
      newdatestart.setHours(starttimeobj[0])
      newdatestart.setMinutes(starttimeobj[1])
      newdateend.setHours(endtimeobj[0])
      newdateend.setMinutes(endtimeobj[1])
      let events = this.calendarevents.filter(event => newdatestart <= new Date(event.datestart) && newdateend >= new Date(event.datestart) && event.archive === 0)
      events.sort(function (a,b) {
        return new Date(a.datestart) - new Date(b.datestart)
      })
      return events
    },
    geteventsday: function (day) {
      let events = this.calendarevents.filter(event => new Date(event.datestart).formatDate("YYYY-MM-DD") === new Date(day).formatDate("YYYY-MM-DD") && event.archive === 0)
      events.sort(function (a,b) {
        return new Date(a.datestart) - new Date(b.datestart)
      })
      return events
    },
    isToday (day) {
      let result = false
      let today = new Date()
      let todaystring = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2)
      if (todaystring === day) result = true
      return result
    },
    getdays () {
      let newdate = this.firstday
      this.days.push(newdate.formatDate("YYYY-MM-DD"))
      for (let i = 0; i < 13; i++) {
        newdate.setDate(newdate.getDate() + 1)
        this.days.push(newdate.formatDate("YYYY-MM-DD"))
      }
      return false
    },
    getdatafromserver: function () {
      let today = new Date()
      let payload = {}
      payload.companyid = this.companyid
      payload.locations = this.locations
      payload.services = this.services
      payload.firstday = this.firstday.formatDate("YYYY-MM-DD HH:mm:ss")
      payload.lastday = this.lastday.formatDate("YYYY-MM-DD HH:mm:ss")
      this.$http.post(this.uri, JSON.stringify(payload))
        .then(function (response) {
          let results = []
          let array = []
          array = JSON.parse(response.body)
          this.$store.commit('addservices',array.services)
          this.$store.commit('addlocations',array.locations)
          results = array.calendarevents
          if (this.definedlocations !== '') {
            let locationsarray = this.definedlocations.split(",")
            results = results.filter(event => locationsarray.includes(event.locationid))
          }
          if (this.definedservices !== '') {
            let servicesarray = this.definedservices.split(",")
            results = results.filter(event => servicesarray.includes(event.serviceid))
          }
          this.calendarevents = results
          this.companyservices = array.services
        }, function (reason) {

        })
    }
  }
}
</script>
